import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteCustomField($companyId: ID!, $id: ID!) {
    deleteCustomField(companyId: $companyId, id: $id) {
      customField {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
